import Reports from './pages/Reports';

export default Reports;
